let styleSelects = require('../styled-select/styled-select');
require('./seminar-list.less');

$(function() {
    styleSelects.styleSelects($('.js-styled-select'));

    /**
     * Обработка Ajax перезагрузки компонента семинаров
     * @param element
     */

    var ajaxComponent = function(element) {
        window.mxLoader = window.mxLoader || undefined;

        var $this = $(element);
        var $container = $this.closest('.js-ajax-component');

        if ($container.length === 1) {
            var url = $container.data('ajax--url');
            var data = $container.data('ajax--parameters');

            if (!url) {
                return;
            }

            !$.isPlainObject(data) && (data = {});

            if ($this.is('input') || $this.is('select')) {
                data[element.name] = element.value;
                /**
                 * Если взаимодействие происходит не с постраничной навигацией, номер страницы не должен быть задан в параметрах запроса.
                 * Это сделано во избежание ошибки, при которой установленный фильтр позволяет отобразить меньше страниц,
                 * чем номер страницы, открытой в данный момент. Эта проблема приводила к ошибке "нет данных", когда
                 * скрипт пытался отобразить, например, 3-ю страницу из двух возможных
                 */
                delete data['page'];
            } else if ($this.hasClass('pagination__item')) {
                if ($this.hasClass('pagination__item--current')) {
                    return;
                }

                var href = $this.attr('href');
                var matches = href && href.match ? href.match(/page=([\d]+)/) : [];
                var page = matches ? parseInt(matches[1]) | 0 || 1 : 1;
                data['page'] = page;
            }

            var time = new Date().getTime() + 500;
            $('body, html').animate({ scrollTop: $container.offset().top - 15 }, 400);
            window.mxLoader && window.mxLoader.show();

            $.ajax({
                url: url,
                data: data,
                type: 'get',
                success: function(result) {
                    if (result && result.html) {
                        time = time - new Date().getTime();
                        time = time > 0 ? time : 0;

                        var $html = $(result.html);

                        var $block;
                        var $select;

                        $html.each(function() {
                            $block = $(this);
                            if ($block.hasClass('js-ajax-component')) {
                                var get = $block.data('ajax--get');
                                $select = $('.js-styled-select', $block);

                                var parameters = $block.data('ajax--parameters');
                                if (parameters && parameters['SET_URL'] === 'Y') {
                                    history &&
                                        history.pushState &&
                                        history.pushState(null, '', get ? '?' + get : window.location.pathname);
                                }

                                $select && styleSelects.styleSelects($select);
                                return false;
                            }
                        });

                        setTimeout(function() {
                            $container.replaceWith($html);
                            window.mxLoader && window.mxLoader.hide();
                        }, time);
                    }
                }
            });
        }
    };

    // Обработка при изменении значения фильтра или количества элементов
    $(document).on('change', '.js-ajax-component input, .js-ajax-component select', function() {
        ajaxComponent(this);
        /* Если меняем значение города в фильтре */
        if ($(this).attr('name') === 'city') {
            /* запрос на получение seo-текста */
            $.ajax({
                url: '/ajax/action/page:seminars_list/getSeoTextByLocationCode/?city=' + $(this).val(),
                type: 'get',
                success: function(result) {
                    if (result.code === 200) {
                        $('.js-seminar-seo-text-container').html(result.data['SEO_TEXT_PREVIEW']);
                        $('.js-seminar-seo-text-full-container').html(result.data['SEO_TEXT']);
                    }
                }
            });
        }
    });

    // Обработка при клике на элемент постраничной навигации
    $(document).on('click', '.js-ajax-component .pagination__item', function(event) {
        if ($(this).hasClass('pagination__item--inactive')) {
            return;
        }
        event.preventDefault();
        ajaxComponent(this);
    });

    // Обработка при клике на кнопку записи на семинар
    $(document).on('click', '.js-seminar-entry', function(event) {
        var $this = $(this);
        if ($this.attr('href')) {
            return;
        }

        event.preventDefault();

        // Если не установлен адрес перехода по ссылке семинара, то отображаем форму записи на семинар
        if (!window.seminarEntry) {
            throw new Error('Ошибка вызова окна записи на семинар. На странице не подключен метод "seminarEntry".');
        }

        var seminar = parseInt($this.data('seminar')) | 0;
        if (seminar) {
            window.seminarEntry(seminar, $this.data('date'), $this.data('city'), $this.data('time'), $this.data('place'), $this.data('isfree'));
        }
    });
});



// WEBPACK FOOTER //
// ./blocks/seminar-list/seminar-list.js